// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.toasts {
  position: fixed;
  bottom: 0;
  left: 0;
  margin: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}

.toast {
  background-color: #76bbe9;
  color: #ffffff;
  position: relative;
  letter-spacing: 0.5px;
  width: -moz-max-content;
  width: max-content;
  transition: transform 0.3s;
  font-size: 1.5rem;
  font-weight: 600;
  border: 4px solid white;
  border-radius: 10px;
  padding: 10px 35px;
  box-shadow: 5px 5px 5px 0px rgba(12, 11, 11, 0.77);
}

.toast-icon {
  fill: #ffffff;
}

.alert {
  display: flex;
  align-items: center;
  gap: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/styles/ToastProvider.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;EACrB,uBAAkB;EAAlB,kBAAkB;EAClB,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".toasts {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  margin: 20px;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: flex-start;\n}\n\n.toast {\n  background-color: #76bbe9;\n  color: #ffffff;\n  position: relative;\n  letter-spacing: 0.5px;\n  width: max-content;\n  transition: transform 0.3s;\n  font-size: 1.5rem;\n  font-weight: 600;\n  border: 4px solid white;\n  border-radius: 10px;\n  padding: 10px 35px;\n  box-shadow: 5px 5px 5px 0px rgba(12, 11, 11, 0.77);\n}\n\n.toast-icon {\n  fill: #ffffff;\n}\n\n.alert {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
